import { useEffect } from 'react';

import { RuntimeLoader, useRiveFile } from '@rive-app/react-canvas';
import { observer } from 'mobx-react';

import { useStores } from '../../stores/useStores';

import { RIVE_WASM_RESOURCE } from './constants';

RuntimeLoader.setWasmUrl(RIVE_WASM_RESOURCE);

const RiveFilePreloader: React.FC<{ url: string }> = observer(({ url }) => {
  const { riveFileStore } = useStores();
  const file = useRiveFile({ src: url });

  useEffect(() => {
    if (file) {
      const { status, riveFile } = file;
      const shouldCacheNewFile = status === 'success' && riveFile && !riveFileStore.getFile(url);
      if (shouldCacheNewFile) {
        riveFileStore.setFile(url, riveFile);
      }
    }
  }, [file, riveFileStore, url]);

  return null;
});

export default RiveFilePreloader;
